import React, { useState } from 'react';
import api from '../utils/axiosConfig';
import Swal from 'sweetalert2';

const AdmitCard = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    applicant_mobile_no: '',
    nid_birth_certificate: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    const response = await api.post('download-admit-card', formData, {
      responseType: 'blob', // important for binary files like PDF
    });
    console.log(response)

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'admit-card.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
    
  } catch (err) {
    console.log(err.response)
    if (err.response && err.response.data instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const errorData = JSON.parse(reader.result);
          Swal.fire({
            title: errorData.title || 'Error!',
            text: errorData.message || 'Something went wrong.',
            icon: errorData.icon || 'error',
          });
        } catch (parseError) {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong.',
            icon: 'error',
          });
        }
      };
      reader.readAsText(err.response.data);
    } else {
      Swal.fire({
        title: 'Error!',
        text: 'Something went wrong.',
        icon: 'error',
      });
    }
  }
  finally {
    setIsSubmitting(false);
  }
};





  

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="card shadow-lg p-4" style={{ maxWidth: '500px', width: '100%' }}>
        <h3 className="text-center mb-4">Download Admit Card</h3>
        <form onSubmit={handleSubmit} disabled={isSubmitting}>
          <div className="mb-3">
            <label htmlFor="applicant_mobile_no" className="form-label">
              Applicant's Mobile No
            </label>
            <input
              type="text"
              className="form-control"
              id="applicant_mobile_no"
              name="applicant_mobile_no"
              value={formData.applicant_mobile_no}
              onChange={handleChange}
              placeholder="Enter your mobile number"
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="nid_birth_certificate" className="form-label">
              NID or Birth Certificate No
            </label>
            <input
              type="text"
              className="form-control"
              id="nid_birth_certificate"
              name="nid_birth_certificate"
              value={formData.nid_birth_certificate}
              onChange={handleChange}
              placeholder="Enter your NID or Birth Certificate No"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary w-100">
            Download Admit Card
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdmitCard;
